import React from 'react';
import './App.css';
import ArtDisplay from './components/ArtDisplay';

function App() {
  return <ArtDisplay />;
}

export default App;